<template>
  <v-main v-if="$mq !== 'small' && $mq !== 'medium'">
    <v-container flex-column>
      <v-layout align-center justify-center>
        <v-flex class="auth-panel">
          <v-card class="login--form" outlined>
            <validation-observer
              tag="form"
              ref="login"
              class="auth-panel--form"
              @submit.prevent="onSubmit()"
            >
              <div class="h1">Log in to Apio</div>
              <LoginButton type="google" />
              <div class="h3 mt-3 mb-3">or</div>
              <v-form>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="email"
                  tag="div"
                  class=""
                >
                  <div class="small-extra-bold apioshade2--text ">Email address</div>
                  <v-text-field
                    tabindex=1
                    class="auth-panel--username"
                    :class="{ 'auth-panel--field-error': errors[0] }"
                    dense
                    outlined
                    :error="true"
                    required
                    v-model="email"
                    placeholder="Type here..."
                    autocomplete="username email"
                    :hide-details="true"
                  >
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="password"
                  tag="div"
                  class="input-group auth-panel--form-group"
                >
                  <v-btn
                    text
                    class="auth-panel--form-forgotten-password"
                    @click="$emit('login-section', 'reset-password')"
                    >Forgotten your password?</v-btn
                  >
                  <div class="small-extra-bold apioshade2--text ">Password</div>
                  <v-text-field
                    tabindex=2
                    v-model="password"
                    :class="{ 'auth-panel--field-error': errors[0] }"
                    :hide-details="true"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="current-password"
                    class="auth-panel--password"
                    dense
                    outlined
                    placeholder="Type here..."

                  >
                  <template slot="append">
                    <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-if="showPassword" name="ui-eye-open" />
                    <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-else name="ui-eye-closed" />
                  </template>
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>
                  <apio-button class="auth-panel--sign-in" @click="onSubmit()" tabindex=3
                    >Sign in</apio-button
                  >
                  <v-spacer />
              </v-form>
            </validation-observer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
  <v-main v-else>
    <v-container>
      <v-layout align-center justify-center flex-column>
        <v-flex class="auth-panel-mobile">
          <v-card class="login--form" outlined>
            <validation-observer
              tag="form"
              ref="login"
              class="auth-panel--form"
              @submit.prevent="onSubmit()"
            >
              <div class="h1">Log in to Apio</div>

              <LoginButton type="google" />

              <div class="h3 mt-3 mb-3">or</div>

              <div class="h3">Enter your details below</div>
              <v-form>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="email"
                  tag="div"
                  class=""
                >
                  <div class="small-extra-bold apioshade2--text ">Email address</div>
                  <v-text-field
                    class="auth-panel--username"
                    :class="{ 'auth-panel--field-error': errors[0] }"
                    dense
                    outlined
                    :error="true"
                    required
                    v-model="email"
                    placeholder="Type here..."
                    autocomplete="username email"
                    :hide-details="true"
                  >
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="password"
                  tag="div"
                  class="input-group auth-panel--form-group"
                >
                  <v-btn
                    text
                    class="auth-panel--form-forgotten-password"
                    @click="$emit('login-section', 'reset-password')"
                    >Forgotten your password?</v-btn
                  >
                  <div class="small-extra-bold apioshade2--text ">Password</div>
                  <v-text-field
                    v-model="password"
                    :class="{ 'auth-panel--field-error': errors[0] }"
                    :hide-details="true"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="current-password"
                    class="auth-panel--password"
                    dense
                    outlined
                    placeholder="Type here..."
                  >
                    <template slot="append">
                      <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-if="showPassword" name="ui-eye-open" />
                      <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-else name="ui-eye-closed" />
                    </template>
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>
                  <apio-button class="auth-panel--sign-in" @click="onSubmit()"
                    >Sign in</apio-button
                  >
                  <v-spacer />
              </v-form>
            </validation-observer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    email: "",
    password: "",
    showPassword: false,
  }),
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    LoginButton: () => import("@/components/Account/LoginButton.vue"),
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  methods: {
    async onSubmit() {
      const valid = await this.$refs.login.validate();
      valid ? this.login() : false;
    },
    login() {
      // Username is still used below as is what the backend requires at the moment
      this.$store.dispatch("login", {
        username: this.email,
        password: this.password,
      });
    },
  },
  created() {
    this.$store.dispatch("resetAppsState");
    this.$store.dispatch("resetAuthState");
    this.$store.dispatch("resetDashboardState");
    this.$store.dispatch("resetUsersState");
  }
};
</script>

<style scoped lang="scss">

.login--form.v-card.v-sheet.v-sheet--outlined.theme--light {
  border: none;
}

apio-button {
  text-transform: none;
}
.form-field-error {
  display: flex;
  visibility: visible;
}

.theme--light.v-application {
  background: transparent;
}

.h3 {
  font-weight: normal;
  color: var(--apio-shade-2);
  margin-bottom: 40px;
}

.h1 {
  color: var(--apio-shade-2);
  margin-bottom: 8px;
}

.container {
  padding: 0;
}

.v-messages {
  position: absolute !important;
  top: -16px;
}

.v-input__prepend-inner {
  height: 16px !important;
}

.v-sheet--outlined {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-sheet.v-card {
  border-radius: 0;
  height: 576px;

  @media only screen and (max-width: 763px) {
    height: 100%;
    padding: 40px 20px;
    width: 100%;
  }
}

.apio {
  &--panel {
    width: 384px;
    height: 576px;

    &-mobile {
      width: calc(100vw);
      height: 393px;
      display: inline-flex;
      align-items: center;
      padding: 0 !important;
      margin: 0 !important;

      &-inner {
        display: flex;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.35);
        padding: 0 !important;
        margin: 0 !important;
        height: 393px !important;
        width: 100%;
      }
    }

    &-inner {
      display: flex;
      flex-direction: column;
      background-color: rgba(0, 0, 0, 0.35);

      @media only screen and (max-width: 763px) {
        height: 439px;
        padding: 0 20px;
        width: 100%;
      }
    }
  }
}

.auth-panel {
  width: 384px;
  height: 576px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &-mobile {
    width: 320px;
//    margin: 40px 20px 0;
  }

  &--heading {
    margin: 0 0 16px 0;
  }

  &--sign-in {
    margin-top: 12px;
    width: 100%;
    text-transform: none;
  }

  &--get-started {
    margin-top: 12px;
    width: 100px;
    text-transform: none;
  }

  &--field {
    &-error {
      border: 1px solid var(--apio-error);
    }
  }

  &--form {
    position: relative;
    width: 305px;

    &-mobile {
      width: 320px;
    }

    &-title {
      margin-bottom: 16px;
    }

    &-group {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: stretch;
      width: 100%;
      position: relative;
      margin: 0 0 1rem 0;
    }

    &-error {
      position: absolute;
      left: 0;
      bottom: -1.2rem;
      color: #dc3545;
      font-size: 12px;
    }

    &-forgotten-password {
      color: var(--apio-purple);
      font-size: 12px !important;
      line-height: 1.33;
      height: 22px !important;
      padding: 0 !important;
      position: absolute;
      right: 0;
      top: -5px;
    }
  }

  &--logo {
    width: 90px;
    margin-bottom: 8px;
    display: block;
  }
}
</style>
